import { render, staticRenderFns } from "./SamMultiSelect.vue?vue&type=template&id=0871a6fb&scoped=true&shadow"
import script from "./SamMultiSelect.vue?vue&type=script&lang=js&shadow"
export * from "./SamMultiSelect.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamMultiSelect.vue?vue&type=style&index=0&id=0871a6fb&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0871a6fb",
  null
  ,true
)

export default component.exports